var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto",attrs:{"flat":""}},[_c('v-card-title',[_vm._v("Number of Items Per Category "),_c('v-spacer')],1),_c('v-card-text',[_c('PieChart',{attrs:{"pieData":_vm.pieData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }